export default __webpack_public_path__ + "static/media/cards-grey.5752199e.svg";